import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../../pages/counter/counterSlice";
import postsReducer from "../../pages/posts/postSlice";
import themeReducer from "../theme/themeSlice";
import sideNavBarReducer from "../../layouts/sideNavBar/sideNavBarSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    posts: postsReducer,
    theme: themeReducer,
    sideNavBar: sideNavBarReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
